import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M64 256c0-35.3 28.7-64 64-64h9.6c14.6 28.5 44.2 48 78.4 48h62l-39.6 52.8 38.4 28.8L320 264l43.2 57.6 38.4-28.8L362 240h62c34.2 0 63.8-19.5 78.4-48h9.6c35.3 0 64 28.7 64 64v128H64zm0 192h512v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64z",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", { d: "M218.2 112H216c-22.1 0-40 17.9-40 40s17.9 40 40 40h73.3l-34.8-59.2c-7.6-12.9-21.4-20.8-36.3-20.8M278 240h-62c-48.6 0-88-39.4-88-88s39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4l24.1 41 24.1-41C360.3 80.9 389.9 64 421.8 64h2.2c48.6 0 88 39.4 88 88s-39.4 88-88 88h-62l39.6 52.8-38.4 28.8L320 264l-43.2 57.6-38.4-28.8zm106-48h40c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8L350.7 192zm192 256H64v-64h512z" }, null, -1)
  ]))]))
}
export default { render: render }